export function assertNever(_x: never): never {
    throw new Error();
}

export function plural(count: number, singular: string, plural: string): string {
    return count === 1 ? singular : plural;
}

/**
 * Prevents the Enter key from submitting a form.
 * Use this handler on form elements to disable Enter key submission.
 *
 * @example
 * <form onSubmit={handleSubmit} onKeyDown={preventEnterSubmit}>
 */
export function preventEnterSubmit(e: React.KeyboardEvent<HTMLFormElement>): void {
    if (e.key !== 'Enter') {
        return;
    }

    const target = e.target as HTMLElement | null;
    if (!target) {
        return;
    }

    const tagName = target.tagName;

    // Allow Enter in textareas to create a new line.
    if (tagName === 'TEXTAREA') {
        return;
    }

    // Allow Enter on buttons to trigger their default behavior (e.g., submit).
    if (tagName === 'BUTTON') {
        return;
    }

    if (tagName === 'INPUT') {
        const input = target as HTMLInputElement;
        const submitLikeTypes = ['submit', 'button', 'reset', 'image'];

        // Allow Enter on submit-like inputs to behave normally.
        if (submitLikeTypes.includes(input.type)) {
            return;
        }
    }

    // For other elements (e.g., text inputs), prevent Enter from submitting the form.
    e.preventDefault();
}
